var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinityPleased(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250.614,
    height: 458.41,
    viewBox: "0 0 250.614 458.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.643,
    y1: 147.397,
    x2: 2.675,
    y2: 147.89,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#7fbfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#79bbde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#6bb1d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#53a0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#3189c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4.462,
    y1: 50.957,
    x2: 5.472,
    y2: 51.502,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1.766,
    y1: 0.12,
    x2: 0.688,
    y2: 0.518,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12518",
    "data-name": "Group 12518",
    transform: "translate(4151 5434.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    transform: "translate(-4151 -5001.071)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 125.307,
    cy: 12.672,
    rx: 125.307,
    ry: 12.672,
    transform: "translate(0 0)",
    fill: "#707070",
    opacity: 0.18
  })), /*#__PURE__*/React.createElement("g", {
    id: "Infinity_4",
    "data-name": "Infinity 4",
    transform: "translate(-4296.961 -5472.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M388.413,400.175q0,3.257-.194,6.5a107.574,107.574,0,0,1-1.712,13.556,111.147,111.147,0,0,1-5.825,19.981,115.2,115.2,0,0,1-7.74,15.921,117.5,117.5,0,0,1-39.149,40.456q-4.527,2.833-9.355,5.233a110.319,110.319,0,0,1-81.582,6.734c-.768-.238-1.536-.485-2.295-.741q-3.879-1.284-7.607-2.851c-.777-.327-1.544-.653-2.3-1-.124-.053-.247-.115-.371-.168a115.93,115.93,0,0,1-45.327-36.864c-.362-.494-.724-.988-1.086-1.492a119.551,119.551,0,0,1-8.252-13.238c-.3-.547-.591-1.094-.874-1.65a117.734,117.734,0,0,1-6.751-15.8,110.731,110.731,0,0,1-3.768-13.662,105.813,105.813,0,0,1-2.259-20.916,99.913,99.913,0,0,1,2.577-23.264c4.148-18.021,12.788-33.069,21.8-44.727v-.009a144.583,144.583,0,0,1,12.073-13.7,128.383,128.383,0,0,1,16.909-14.421l.106-.026c.291-.088.582-.177.874-.256a249.842,249.842,0,0,1,94.5-8.455q3.058.3,5.939.671c.009,0,.018.009.026.009.688.079,1.377.168,2.047.256.106.018.2.026.309.044q2.608,1.244,5.136,2.595c.291.15.574.309.856.468a126.826,126.826,0,0,1,30.165,22.743v.009a122.074,122.074,0,0,1,8.411,9.514c1.474,1.853,2.895,3.751,4.245,5.684q1.363,1.92,2.63,3.892a114.187,114.187,0,0,1,11.394,22.92,105.656,105.656,0,0,1,3.618,12.091,104.288,104.288,0,0,1,2.833,23.961Z",
    transform: "translate(0 -29.997)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M331.631,300.987a2.677,2.677,0,0,1-.521,1.677c-.971,1.483-3.327,2.974-6.8,4.4-.018.009-.044.018-.062.026a85.392,85.392,0,0,1-12.258,3.689c-.335.079-.671.159-1.015.238a237.33,237.33,0,0,1-35.24,4.757c-5.639.379-11.1.574-16.265.609h-.009c-17,.132-30.765-1.465-37.173-4.254-.282-.124-.547-.256-.8-.38a5.641,5.641,0,0,1-2.939-2.612,2.307,2.307,0,0,1-.159-.68,2.631,2.631,0,0,1,.035-.574,2.413,2.413,0,0,1,.185-.574,4.849,4.849,0,0,1,1.359-1.712c.168-.141.344-.282.521-.432a.269.269,0,0,0,.062-.044,18.025,18.025,0,0,1,2.374-1.456c8.543-4.448,28.241-8.464,51.355-9.99,18.789-1.244,35.566-.556,46.042,1.518a.032.032,0,0,1,.026.009c1.077.212,2.083.441,3.018.68.009,0,.018.009.026.009,4.21,1.086,6.981,2.453,7.9,4.051a2.445,2.445,0,0,1,.335,1.05Z",
    transform: "translate(-6.628 -29.883)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M207.6,350.8a208.223,208.223,0,0,0-21.312,46.154,37.445,37.445,0,0,1-21.411-14.97c4.148-18.021,12.788-33.069,21.8-44.727A32.674,32.674,0,0,0,207.6,350.8Z",
    transform: "translate(-0.343 -35.076)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M405.159,367.862a37.32,37.32,0,0,1-19.345,16.848,207.479,207.479,0,0,0-26.37-43.456,32.949,32.949,0,0,0,11.632-6.363,32.572,32.572,0,0,0,7.4-9.037,122.079,122.079,0,0,1,8.411,9.514c1.474,1.853,2.895,3.751,4.245,5.684q1.363,1.92,2.63,3.892a114.188,114.188,0,0,1,11.394,22.92Z",
    transform: "translate(-23.196 -33.736)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 37.064,
    height: 26.474,
    rx: 6.711,
    transform: "translate(252.379 313.912) rotate(-3.806)",
    fill: "#2eb3bd",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M323.207,228.583a11.917,11.917,0,0,1-5.048,3.521,147.552,147.552,0,0,1-57.833,14.527q-1.814.079-3.574.106a146.954,146.954,0,0,1-37.058-4.13c-1.756-.432-3.424-.865-4.986-1.306a11.853,11.853,0,0,1-5.507-2.542,11.622,11.622,0,0,1-4.157-7.961L190.059,63.01a12.165,12.165,0,0,1,2.683-8.569,11.765,11.765,0,0,1,3.027-2.568,12.049,12.049,0,0,1,3.168-1.306h.009A196.764,196.764,0,0,1,300.4,41.6c.106.009.229.026.362.044a11.9,11.9,0,0,1,4.042,1.306,10.855,10.855,0,0,1,1.942,1.306,12.225,12.225,0,0,1,4.166,7.961L325.89,220a12.3,12.3,0,0,1-2.683,8.578Z",
    transform: "translate(-3.296 0)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 9.321,
    height: 81.913,
    transform: "translate(268.153 339.371) rotate(-3.562)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M388.52,421.663a107.574,107.574,0,0,1-1.712,13.556,184.736,184.736,0,0,1-28.029,18.092c-.079.044-.159.079-.238.124-40.217,20.969-77.249,21.252-91.9,21.19A218.833,218.833,0,0,1,186.251,458.1c-6.91-2.833-12.938-5.728-17.96-8.358a110.737,110.737,0,0,1-3.768-13.662c3.027,1.677,6.513,3.513,10.414,5.41a219.8,219.8,0,0,0,80.055,21.763c6.557.432,12.735.512,18.4.388,3.283-.079,6.39-.229,9.311-.432a180.6,180.6,0,0,0,25.152-3.354,195.253,195.253,0,0,0,52.635-19.734c5.057-2.762,10.264-5.887,15.542-9.408,4.9-3.265,9.081-6.381,12.488-9.055Z",
    transform: "translate(-0.301 -44.99)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M242.379,528.862q-3.879-1.284-7.607-2.851c-.777-.327-1.544-.653-2.3-1a105.3,105.3,0,0,0,.68-15.188,10.973,10.973,0,0,0-2.224-6.928,10.736,10.736,0,0,0-4.369-2.965,9.562,9.562,0,0,0-2.206-.432,202.8,202.8,0,0,1-37.579-11.517c-.362-.494-.724-.988-1.086-1.491a119.55,119.55,0,0,1-8.252-13.238c.265.132.547.274.821.406a226.565,226.565,0,0,0,53.835,18.189,11.931,11.931,0,0,1,2.462.485,13.069,13.069,0,0,1,9.32,12.523,107.008,107.008,0,0,1-1.491,24.005Z",
    transform: "translate(-1.817 -51.05)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M401.724,459.667a115.2,115.2,0,0,1-7.74,15.921,203.173,203.173,0,0,1-34.1,15.339,9.341,9.341,0,0,0-2.136.724,10.83,10.83,0,0,0-3.954,3.495,11.013,11.013,0,0,0-1.3,7.166,106.406,106.406,0,0,0,2.339,13.732q-4.527,2.833-9.355,5.233a106.592,106.592,0,0,1-4.263-22.5,13.075,13.075,0,0,1,7.616-13.626,11.992,11.992,0,0,1,2.383-.794,226.914,226.914,0,0,0,50.508-24.685Z",
    transform: "translate(-21.042 -49.454)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M316.142,200.571c-2.621,1.165-5.013,2.348-7.157,3.486a9.63,9.63,0,0,0-4.219,3.31,12.188,12.188,0,0,0-2.127,4.96,13.6,13.6,0,0,0-.2,3.512l.4,5.975a104.358,104.358,0,0,1-59.068,8.931,108.337,108.337,0,0,1-12.647-2.551l-1.094-6.981a13.611,13.611,0,0,0-.98-3.38,12.175,12.175,0,0,0-3.168-4.369,9.5,9.5,0,0,0-4.845-2.295c-2.047-.565-4.289-1.112-6.707-1.615l-14.2-158.989h.009a196.649,196.649,0,0,1,93.726-10.158c2.736.362,5.313.768,7.731,1.191.106.009.229.026.362.044l14.191,158.928Z",
    transform: "translate(-4.483)",
    fill: "#353f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M251.708,124.683a25.222,25.222,0,0,0-26.01,9.695,5.281,5.281,0,0,1-3.953-.142,5.15,5.15,0,0,1-2.694-2.9l-.882-2.365a5.459,5.459,0,0,1,.142-3.953,5.175,5.175,0,0,1,1.49-1.9,30.787,30.787,0,0,1,29.487-10.8,5.143,5.143,0,0,1,4.577,3.348l.882,2.365a5.167,5.167,0,0,1-3.038,6.647Z",
    transform: "translate(-6.566 -8.596)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M301.2,126.26a29.164,29.164,0,0,0-27.63-2.666,5.276,5.276,0,0,1-3.492-1.858,5.154,5.154,0,0,1-1.156-3.783l.292-3.026a5.465,5.465,0,0,1,1.858-3.492,5.155,5.155,0,0,1,2.058-1.027,42.752,42.752,0,0,1,31.209,3.089,5.144,5.144,0,0,1,2.793,5.09l-.292,3.026a5.168,5.168,0,0,1-5.64,4.647Z",
    transform: "translate(-12.561 -8.239)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M317.431,295.206c-11.552.388-27.959,4.8-39.908,12.947-3,2.047-8.94,6.522-18.048,8.225h-.009c-4.263.794-7.422.653-12.153.406-7.731-.406-19.107-1.968-25.02-4.66-.282-.124-.547-.256-.8-.379a6.02,6.02,0,0,1-2.939-2.612,2.307,2.307,0,0,1-.159-.68,2.631,2.631,0,0,1,.035-.574,2.868,2.868,0,0,1,.185-.574,5.363,5.363,0,0,1,1.359-1.712c.168-.141.344-.282.521-.432a.27.27,0,0,0,.062-.044c.477-.388.98-.794,1.5-1.2.291-.088.582-.177.874-.256,8.543-4.448,28.241-8.464,51.355-9.99,18.789-1.244,35.566-.556,46.042,1.518-.927-.026-1.889-.026-2.895.018Z",
    transform: "translate(-6.628 -29.883)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M406,400.823q0,3.257-.194,6.5a107.574,107.574,0,0,1-1.712,13.556,111.147,111.147,0,0,1-5.825,19.981,115.2,115.2,0,0,1-7.74,15.921,117.5,117.5,0,0,1-39.149,40.456q-4.527,2.833-9.355,5.233a109.892,109.892,0,0,1-27.412,9.426,158.516,158.516,0,0,0,20.934-14.7c12.47-10.343,27.835-23.1,36.475-45.495a87.321,87.321,0,0,0,3.8-12.6,91.694,91.694,0,0,0,1.95-13.309,131.54,131.54,0,0,0,.132-14.88c-1.059-29.311-14.518-52.176-14.518-52.176-4.757-8.5-13.286-23.348-30.787-34.905a87.257,87.257,0,0,0-20.9-10.083c1.838-.33,16.671-3,19.141-4.037a35.838,35.838,0,0,0,4.369-1.853c.018-.009.044-.018.062-.026a37.871,37.871,0,0,0,6.8-4.4,6.217,6.217,0,0,0,.185-2.727,3.564,3.564,0,0,0-.406-1.156,127.185,127.185,0,0,1,31.021,23.211v.009a122.073,122.073,0,0,1,8.411,9.514c1.474,1.853,2.895,3.751,4.245,5.684q1.363,1.92,2.63,3.892a114.186,114.186,0,0,1,11.394,22.92,105.642,105.642,0,0,1,3.618,12.091A104.286,104.286,0,0,1,406,400.823Z",
    transform: "translate(-17.589 -30.646)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M332.088,229.156a11.917,11.917,0,0,1-5.048,3.521A147.552,147.552,0,0,1,269.207,247.2q-1.814.079-3.574.106c26.617-6.557,45.91-13,52.988-17.307,1.853-1.121,5.789-3.513,7.846-8.234a17.809,17.809,0,0,0,.785-10.988q-5.626-67.263-10.979-134.534-1.311-16.362-2.586-32.725a10.856,10.856,0,0,1,1.942,1.306,12.225,12.225,0,0,1,4.166,7.961l14.977,167.788a12.3,12.3,0,0,1-2.683,8.578Z",
    transform: "translate(-12.177 -0.574)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M321.95,200.806c-2.621,1.165-5.013,2.348-7.157,3.486a9.63,9.63,0,0,0-4.219,3.31,12.188,12.188,0,0,0-2.127,4.96,13.6,13.6,0,0,0-.2,3.512l.4,5.975a104.358,104.358,0,0,1-59.068,8.931,224.887,224.887,0,0,0,40.632-14.844A38.778,38.778,0,0,0,296.083,213c18.5-12.973,14.129-45.415,9.417-97.273-1.58-17.4-3.751-43.1-5.834-75.086,2.736.362,5.313.768,7.731,1.191.106.009.229.026.362.044L321.95,200.806Z",
    transform: "translate(-10.291 -0.235)",
    fill: "#15192f",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M213.965,169.758q-4.51-56.483-9.021-112.965a135.391,135.391,0,0,1,13.336-4.707A138.629,138.629,0,0,1,262.6,46.6c-5.9,1.628-14.6,4.212-25.037,8.02-9.542,3.482-11.44,4.668-12.679,5.592-10.606,7.915-10.539,24.784-10.53,35.026.022,22.839-.206,46.831-.392,74.525Z",
    transform: "translate(-5.049 -0.923)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M219.694,244.367c-1.756-.432-3.424-.865-4.986-1.306a11.853,11.853,0,0,1-5.507-2.542,11.622,11.622,0,0,1-4.157-7.961L190.059,64.771a12.165,12.165,0,0,1,2.683-8.569,11.765,11.765,0,0,1,3.027-2.568c-.459,2.709-.9,5.9-1.209,9.487a116.963,116.963,0,0,0,0,20.007c2.683,32.883,4.024,49.334,5.887,70.991,1.986,23.061,6.61,45.91,7.449,69.041a25.673,25.673,0,0,0,1.571,8.234,28.851,28.851,0,0,0,10.229,12.973Z",
    transform: "translate(-3.296 -1.761)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M230.28,507.049a115.93,115.93,0,0,1-45.327-36.864c-.362-.494-.724-.988-1.086-1.491a119.553,119.553,0,0,1-8.252-13.238c-.3-.547-.591-1.094-.874-1.65a117.738,117.738,0,0,1-6.751-15.8,110.734,110.734,0,0,1-3.768-13.662,105.813,105.813,0,0,1-2.259-20.916,99.912,99.912,0,0,1,2.577-23.264c4.148-18.021,12.788-33.069,21.8-44.727v-.009a144.575,144.575,0,0,1,12.073-13.7c-1.977,3.477-4.13,7.413-6.363,11.755-6.751,13.123-14.368,27.915-18.436,43.933-.644,2.551-6.946,28.453-.388,56.085,9.231,38.938,39.573,62.678,57.056,73.542Z",
    transform: "translate(0 -33.252)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M342.372,301.4c-.406,1.739-1.686,3.071-3.565,4.254a.184.184,0,0,0-.053.035,52.882,52.882,0,0,1-8.128,3.663,63.743,63.743,0,0,1-20.722,4.3h-.071a123.334,123.334,0,0,0,12.161-4.3c8.658-3.574,13.017-5.419,14.121-8.631a7.04,7.04,0,0,0,.159-3.8c-.026-.115-.053-.238-.088-.362.106.018.2.026.309.044q2.608,1.244,5.136,2.595c.291.15.574.309.856.468A5.422,5.422,0,0,1,342.372,301.4Z",
    transform: "translate(-17.369 -30.295)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M276,369.906A5.685,5.685,0,0,1,271,363.881a5.67,5.67,0,0,1,2.052-4.034A5.535,5.535,0,0,1,276,358.769c3.341-.337,5.954,1.985,6.524,2.49.778.691,1.8,1.839,2.037,2.108.737.83.985,1.188,1.405,1.683a10.28,10.28,0,0,0,4.183,3.4,6.117,6.117,0,0,0,4.456.028,5.983,5.983,0,0,0,3.143-3.206,5.547,5.547,0,0,0,.266-3.883,5.3,5.3,0,0,0-1.248-2.014,5.864,5.864,0,0,0-2.3-1.487,7.4,7.4,0,0,0-6.368,1.417,13.226,13.226,0,0,0-1.668,1.489l-.16.176a14.787,14.787,0,0,0-1.714,2.393c-.58.96-.667,1.273-1.027,1.908a9.36,9.36,0,0,1-3.644,3.815,6.325,6.325,0,0,1-3.89.815Z",
    transform: "translate(-12.807 -37.475)",
    fill: "none",
    stroke: "#139093",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityPleased);
export default __webpack_public_path__ + "static/media/infinity-pleased.608594c33791475147258f866bf63cac.svg";
export { ForwardRef as ReactComponent };